namespace $ {
	export type $shm_projects_goal_attachment = {
		id: string
		name: string
		type: string
		data: string
		file?: File
	}
}

namespace $.$$ {
	export class $shm_projects_goal_request extends $.$shm_projects_goal_request {

		request_content() {
			return [
				this.Field(),
				...( this.attachments().length ? [ this.Attachments() ] : [] ),
				... this.after(),
			]
		}

		@ $mol_mem
		drag_depth( next?: number ) {
			return next ?? 0
		}

		image_files( files: FileList | readonly File[] | null | undefined ) {
			const supported = new Set([ 'image/png', 'image/jpeg', 'image/gif', 'image/webp' ])
			return [ ... ( files ?? [] ) ].filter( file => supported.has( file.type.toLowerCase() ) )
		}

		attachments_add( files: readonly File[] ) {
			const images = this.image_files( files ).slice( 0, Math.max( 0, 10 - this.attachments().length ) )
			if( !images.length ) return this.attachments()
			const added = images.map( ( file, index )=> ({
				id: `${ this.attachments().length + index }-${ file.name }-${ file.size }-${ file.lastModified }`,
				name: file.name || `Изображение ${ this.attachments().length + index + 1 }`,
				type: file.type,
				data: URL.createObjectURL( file ),
				file,
			}) )
			return this.attachments([ ... this.attachments(), ... added ])
		}

		attachments_payload() {
			return this.attachments().map( ({ file, ...attachment })=> file ? ({
				... attachment,
				data: `data:${ file.type };base64,${ $mol_base64_encode( new Uint8Array( $mol_wire_sync( file ).arrayBuffer() ) ) }`,
			}) : attachment )
		}

		override image_paste( next?: ClipboardEvent ) {
			if( !next ) return null
			const files = this.image_files( next.clipboardData?.files )
			if( !files.length ) return next
			next.preventDefault()
			this.attachments_add( files )
			return next
		}

		drag_files( event: DragEvent ) {
			return Array.from( event.dataTransfer?.types ?? [] ).includes( 'Files' )
		}

		override drag_enter( next?: DragEvent ) {
			if( !next || !this.drag_files( next ) ) return next ?? null
			next.preventDefault()
			this.drag_depth( this.drag_depth() + 1 )
			this.drag_active( true )
			return next
		}

		override drag_over( next?: DragEvent ) {
			if( !next || !this.drag_files( next ) ) return next ?? null
			next.preventDefault()
			if( next.dataTransfer ) next.dataTransfer.dropEffect = 'copy'
			return next
		}

		override drag_leave( next?: DragEvent ) {
			if( !next || !this.drag_active() ) return next ?? null
			const depth = Math.max( 0, this.drag_depth() - 1 )
			this.drag_depth( depth )
			if( !depth ) this.drag_active( false )
			return next
		}

		override file_drop( next?: DragEvent ) {
			if( !next ) return null
			const files = this.image_files( next.dataTransfer?.files )
			if( !files.length ) return next
			next.preventDefault()
			this.drag_depth( 0 )
			this.drag_active( false )
			this.attachments_add( files )
			return next
		}

		attachment_rows() {
			return this.attachments().map( attachment => this.Attachment( attachment.id ) )
		}

		attachment( id: string ) {
			return this.attachments().find( attachment => attachment.id === id )
		}

		attachment_uri( id: string ) {
			return this.attachment( id )?.data ?? ''
		}

		attachment_name( id: string ) {
			return this.attachment( id )?.name ?? ''
		}

		override attachment_remove( id: string, next?: Event ) {
			if( next === undefined ) return null
			const attachment = this.attachment( id )
			if( attachment?.file ) URL.revokeObjectURL( attachment.data )
			this.attachments( this.attachments().filter( attachment => attachment.id !== id ) )
			return next
		}

	}
}
